

export const DEFAULT_DASHBOARD_LAYOUT = {
    current_breakpoint: "lg",
    compact_type: "vertical",
    mounted: false,
    layouts: {lg: [{i: "1", x: 1, y: 1, w: 2, h: 3, static: false}]}
}
